import { isObject } from 'lodash-es'

export function datetimeAsString(datetime) {
    if (isObject(datetime)) {
        return datetime.datetime
    }
    return datetime
}
